import { render, staticRenderFns } from "./ANxAPxDrugsPage.vue?vue&type=template&id=4a363a19"
import script from "./ANxAPxDrugsPage.vue?vue&type=script&lang=js"
export * from "./ANxAPxDrugsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports